
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/complaints",
      function () {
        return require("private-next-pages/complaints.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/complaints"])
      });
    }
  